import { createAuth0 } from '@auth0/auth0-vue';

export const auth0 = createAuth0({
  domain: 'https://auth.cms.westerninterlock.com',
  clientId: 'tO8A1Jaqz7OQnuPvllgxNVlHNvJQPMY1',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'http://localhost:3128',
    scope: 'openid profile email',
  },
});
